module.exports={author:"Jackson Holbert",date:"10/31/2019",publishDate:"10/31/2019",highlighted:!1,tags:"",title:"Poem Involving the Sea",badge:null};